import moment from 'moment';
import { windowObject } from '../../utils.js';
var TrackerHitTypeLID = function (value) {
  return {
    PageView: 207,
    Event: 208,
    Transaction: 209,
    Social: 210,
    Timing: 211,
    DecorateLink: 212,
    DecorateForm: 213
  }[value];
};
export var TrackerHitTypeLID_ENUM = {
  PageView: "PageView",
  Event: "Event",
  Transaction: "Transaction",
  Social: "Social",
  Timing: "Timing",
  DecorateLink: "DecorateLink",
  DecorateForm: "DecorateForm"
};
var UserLanguage = function (value) {
  return {
    English: 1,
    Spanish: 2
  }[value];
};
export var UserLanguage_ENUM = {
  English: "English",
  Spanish: "Spanish"
};
var EventStatusLID = function (value) {
  return {
    Exception: 200202,
    Processed: 82,
    Processing: 526,
    ReadyForNotification: 527,
    ProcessingNotification: 528,
    Unprocessed: 81,
    ReadyForSecondaryProcessing: 201323,
    Debugging: 1000156
  }[value];
};
export var EventStatusLID_ENUM = {
  Exception: "Exception",
  Processed: "Processed",
  Processing: "Processing",
  ReadyForNotification: "ReadyForNotification",
  ProcessingNotification: "ProcessingNotification",
  Unprocessed: "Unprocessed",
  ReadyForSecondaryProcessing: "ReadyForSecondaryProcessing",
  Debugging: "Debugging"
};
var EventTypeLID_ENUM = {
  AcceptedTermsAndConditions: 625,
  AccountConfirmed: 244,
  AccountForgotUserName: 150,
  AccountForgotUserNameEmail: 255,
  AccountForgotPasswordEmail: 149,
  AccountForgotPasswordFinished: 258,
  AccountLockedEmail: 584,
  AccountLockedForgotPassword: 200274,
  AccountLockedForgotUserName: 200275,
  CustomerAlreadyAssociatedToUser: 251,
  AnotherUserTriedToAssociateYourLoan: 574,
  AccountLoginFailed: 245,
  AccountLoginFailedUnconfirmed: 573,
  AccountLoginSucessful: 246,
  AccountLoginTwoFactorInputSuccess: 687,
  AccountRegistered: 143,
  AchActiveCancelled: 146,
  AchActiveEdited: 145,
  AchPaymentFailed: 621,
  AchPaymentSucceeded: 631,
  AchSetupFailed: 184,
  AchSetupRequested: 254,
  AchSetupSucceeded: 144,
  AchChangeSucceeded: 200200,
  AchChangeFailed: 200201,
  AutomatedMessage: 183,
  ChangedEmailInformation: 579,
  ChangedMailingAddress: 576,
  ChangedNotificationElections: 252,
  ChangedPaperlessElections: 253,
  ChangedPrivacyPreferences: 202456,
  ChangedPassword: 243,
  ChangedPhoneInformation: 250,
  ChangedSecurityImage: 524,
  ChangedSecurityQuestions: 182,
  ChangedUserName: 262,
  OptedDocsSpanish: 202427,
  OptedDocsEnglish: 202428,
  OptedCommSpanish: 202429,
  OptedCommEnglish: 202430,
  DeactivatedUserName: 201374,
  DeclinedTermsAndConditions: 632,
  LoanAssociationAccepted: 572,
  LoanAssociationAccountLocked: 571,
  LoanAssociationLockedEmail: 523,
  LoanAssociationRemoved: 570,
  LoanAssociationAttemptFailure: 201373,
  LoanAssociationAttemptSuccess: 201372,
  MonthlyStatementAvailable: 142,
  MakeAPaymentCompleteAdditionalAmounts: 659,
  MakeAPaymentCompleteMonthlyPayment: 639,
  MakeAPaymentCompletePrincipalReduction: 641,
  MakeAPaymentCompleteTrialPayment: 679,
  MakeAPaymentMonthlyPayment: 685,
  MakeAPaymentPendingPaymentCancel: 684,
  MakeAPaymentPendingPaymentEdit: 666,
  MakeAPaymentStart: 668,
  MakeAPaymentStartAdditionalAmounts: 653,
  MakeAPaymentStartPrincipalReduction: 683,
  MakeAPaymentStartTrialPayment: 644,
  PaymentFailed: 79,
  PaymentScheduled_IVR: 78,
  PaymentScheduled_Web: 77,
  PaymentSucceeded: 175,
  PayoffDemandRequested: 140,
  PayoffDemandDeliveredtoSecureMessageCenter: 636,
  PayoffProcessed: 141,
  AccountChallengeQuestionAnsweredSuccesfully: 247,
  AccountQuestionAnsweredInCorrectly: 248,
  SecureMessageRead: 181,
  SecureMessageReplied: 578,
  OutBoundSecureMessage: 180,
  InboundSecureMessage: 179,
  SendEmailAddressConfirmationEmail: 237,
  SendEmailVerificationCode: 238,
  SendNoAccountEmail: 240,
  SendSmsNumberConfirmationCode: 261,
  SendSmsVerificationCode: 249,
  SendVerificationCode: 241,
  TaxesPaid: 151,
  TaxesPaidSecureMessage: 201383,
  InsurancePaidSecureMessage: 202385,
  InsurancePremiumsPaid: 139,
  ValidateVerificationCode: 242,
  VerificationPreferenceUpdatedEmail: 256,
  VerifyEmailVerificationToken: 239,
  VerifyEmailVerificationTokenInvalid: 586,
  VerifyForgotUserNameToken: 633,
  VerifyForgotUserNameTokenInvalid: 152,
  VerifySmsVerificationToken: 201329,
  VerifySmsVerificationTokenInvalid: 201330,
  WhiteListDocRequestFulfilled: 166,
  WhiteListDocRequestUnfulfilled: 201322,
  YearEndStatementAvailable: 147,
  WhiteListDocsRequested: 635,
  EmailBounce: 201312,
  SendEmailChangeVerificationCode: 201313,
  SyncCustMartToCustomers: 201327,
  SyncCustMartLoansToMsp: 201328,
  TwoFactorAuthLoginSuccessful: 202407,
  SuccessfullyAuthenticated: 202408,
  PaymentConfirmationEmail: 202418,
  WebChampUserInfoAccess: 202425,
  WebChampUserPreferenceUpdate: 202426,
  LanguageToggledToEnglish: 202431,
  LanguageToggledToSpanish: 202432,
  UpdateIDSEmail: 1000076,
  UpdateIDSMobile: 1000077,
  Debug: 999999,
  DownloadModDoc: 202434,
  DownldStmtDocUI: 202435,
  DownldStmtDocDirect: 202436,
  RedirectRegistrationToPennyHome: 202454,
  PayoffDemand_Document_Ready: 202455,
  RedirectLogInToPennyHome: 202457,
  PayoffDemand_ManuallyProcessed: 209996,
  Payoff_Generated: 210001,
  Payoff_Sent_For_Review: 210002,
  PennyWISE_SecureMessageRead: 210003,
  PennyWISE_DownldStmtDocUI: 210004,
  PennyWISE_DownloadModDoc: 210005,
  PennyWISE_DownldStmtDocDirect: 210006,
  FAQ_Link_Clicked: 210007,
  Wisconsin_Tax_Option_Click: 210008,
  Wisconsin_Tax_Option_Submit: 210009,
  Mod_Center_Clicks: 210010,
  Amortization_Calculator_Clicks: 210011,
  BankAccount_Add: 210012,
  BankAccount_Update: 210013,
  BankAccount_Delete: 210014,
  ModMiscFileUpload_Started: 210015,
  WhiteListedDocNotification: 210016,
  DisasterAssistancePopupDisplay: 210017,
  DisasterAssistanceCancel: 210018,
  DisasterAssistanceGoBack: 1000131,
  DisasterAssistanceSubmit: 210019,
  MakeADelinquent30DayPayment: 210020,
  MakeADelinquent30DayPaymentComplete: 210021,
  PennyPaperlessSignUp: 1000004,
  AchUpdate_OtpOpted: 1000010,
  MobileTokenLoginFailed: 1000012,
  MobileTokenLoginSucessful: 1000013,
  OnboardingAllowPushNotifications: 1000027,
  OnboardingEnableTouchId: 1000028,
  OnboardingSkipNow: 1000029,
  ScheduleQuickPayment: 1000030,
  PaymentScreenDone: 1000031,
  PaymentThankYouPageOk: 1000032,
  AllowPushNotifications: 1000033,
  PaymentReminderDaySelection: 1000034,
  EnableTouchId: 1000035,
  AppSettingsLogout: 1000036,
  AppStateChange: 1000037,
  LoginTouchId: 1000038,
  ModFileUpload_Started: 1000039,
  ModFileUpload_Completed: 1000040,
  ModMiscFileUpload_Completed: 1000041,
  QuickLinkMakeAPaymentClicked: 1000042,
  QuickLinkLoanActivityClicked: 1000043,
  QuickLinkMessageCenterClicked: 1000044,
  QuickLinkMonthlyStatementClicked: 1000045,
  AppNormalLogin: 1000047,
  ServCommOnline: 1000049,
  ServCommBoth: 1000050,
  PMIPageLoadedFromOtherPageEvent: 1000054,
  PMIPageLoadedByNavEvent: 1000055,
  PMIBannerLinkClickedEvent: 1000056,
  AutoLoanAssociationSuccess: 1000057,
  HelocDrawAddRequestSuccess: 1000062,
  HelocDrawAddRequestFailed: 1000063,
  HelocDrawEditRequestSuccess: 1000064,
  HelocDrawEditRequestFailed: 1000065,
  HelocDrawCancelRequestSuccess: 1000066,
  HelocDrawCancelRequestFailed: 1000067,
  MakeADrawStart: 1000070,
  MakeADrawComplete: 1000071,
  HelocBankAccountChanged: 1000075,
  ContinueToBillMatrix: 1000084,
  BackToPennyMacClick: 1000085,
  PaymentWithCheckingClick: 1000086,
  PaymentWithSavingsClick: 1000087,
  PaymentWithDebitCardClick: 1000088,
  ReturnedFromFiserv: 1000089,
  BackToPennyMacPaymentReturn: 1000090,
  RedirectToPendingPayments: 1000091,
  RedirectToPaymentStep1: 1000092,
  NoFiservCuzCashCallFailed: 1000093,
  FiservOkButCashNotOkRedirectToLoanInfo: 1000094,
  UserChangedPaymentMethod: 1000095,
  UserSentToFiServPaymentPage: 1000096,
  EscrowAnalysisAndPaymentChange: 1000101,
  MobAppLoanInformationPageOpened: 1000110,
  MobAppMakeAPaymentPageOpened: 1000111,
  MobAppPendingPaymentsPageOpened: 1000112,
  MobAppLoanActivityPageOpened: 1000113,
  MobAppEscrowPageOpened: 1000114,
  MobAppMoreFeaturesPageOpened: 1000115,
  MobAppOffersPageOpened: 1000116,
  MobAppSettingsPageOpened: 1000117,
  TCPAOnlineAgreementPopUpClick: 1000118,
  OTDConfirmationPopupDisplay: 1000128,
  OTDConfirmationPopupCancelClicked: 1000129,
  OTDConfirmationPopupContinueClicked: 1000130,
  ForbearancePlanPrompt1: 1000137,
  ForbearancePlanPrompt2: 1000138,
  ForbearancePlanPrompt3: 1000139,
  ForbearancePlanPrompt4: 1000140,
  ForbearancePlanPrompt5: 1000141,
  ForbearancePlanPrompt6: 1000142,
  MakeAPaymentCompleteForbearancePayment: 1000146,
  MOVRMessageOnLogInDisplayed: 1000148,
  MOVRLinkClicked: 1000149,
  ReturnedFromMOVR: 1000150,
  ChangePasswordFailed: 1000165,
  DebugLog: 999999,
  LoanAssociationViewRedirected: 1000164,
  ServicingAppRedirected: 1000158,
  RetailAppRedirected: 1000159,
  ServicingLoanSelected: 1000160,
  RetailLoanSelected: 1000161,
  UserLogOutEvent: 1000162,
  RecordLoanAssociation: 1000163,
  TechnicalErrorEncountered: 1000174,
  NoTechnicalErrors: 1000175,
  IdsApiCallForPhoneChange: 1000166,
  IdsApiCallForEmailChange: 1000167,
  FixingLoanAssociationAtUserProfile: 1000168
};
export var EventTypeLID = function (value) {
  return {
    AcceptedTermsAndConditions: "AcceptedTermsAndConditions",
    AccountConfirmed: "AccountConfirmed",
    AccountForgotUserName: "AccountForgotUserName",
    AccountForgotUserNameEmail: "AccountForgotUserNameEmail",
    AccountForgotPasswordEmail: "AccountForgotPasswordEmail",
    AccountForgotPasswordFinished: "AccountForgotPasswordFinished",
    AccountLockedEmail: "AccountLockedEmail",
    AccountLockedForgotPassword: "AccountLockedForgotPassword",
    AccountLockedForgotUserName: "AccountLockedForgotUserName",
    CustomerAlreadyAssociatedToUser: "CustomerAlreadyAssociatedToUser",
    AnotherUserTriedToAssociateYourLoan: "AnotherUserTriedToAssociateYourLoan",
    AccountLoginFailed: "AccountLoginFailed",
    AccountLoginFailedUnconfirmed: "AccountLoginFailedUnconfirmed",
    AccountLoginSucessful: "AccountLoginSucessful",
    AccountLoginTwoFactorInputSuccess: "AccountLoginTwoFactorInputSuccess",
    AccountRegistered: "AccountRegistered",
    AchActiveCancelled: "AchActiveCancelled",
    AchActiveEdited: "AchActiveEdited",
    AchPaymentFailed: "AchPaymentFailed",
    AchPaymentSucceeded: "AchPaymentSucceeded",
    AchSetupFailed: "AchSetupFailed",
    AchSetupRequested: "AchSetupRequested",
    AchSetupSucceeded: "AchSetupSucceeded",
    AchChangeSucceeded: "AchChangeSucceeded",
    AchChangeFailed: "AchChangeFailed",
    AutomatedMessage: "AutomatedMessage",
    ChangedEmailInformation: "ChangedEmailInformation",
    ChangedMailingAddress: "ChangedMailingAddress",
    ChangedNotificationElections: "ChangedNotificationElections",
    ChangedPaperlessElections: "ChangedPaperlessElections",
    ChangedPrivacyPreferences: "ChangedPrivacyPreferences",
    ChangedPassword: "ChangedPassword",
    ChangedPhoneInformation: "ChangedPhoneInformation",
    ChangedSecurityImage: "ChangedSecurityImage",
    ChangedSecurityQuestions: "ChangedSecurityQuestions",
    ChangedUserName: "ChangedUserName",
    OptedDocsSpanish: "OptedDocsSpanish",
    OptedDocsEnglish: "OptedDocsEnglish",
    OptedCommSpanish: "OptedCommSpanish",
    OptedCommEnglish: "OptedCommEnglish",
    DeactivatedUserName: "DeactivatedUserName",
    DeclinedTermsAndConditions: "DeclinedTermsAndConditions",
    LoanAssociationAccepted: "LoanAssociationAccepted",
    LoanAssociationAccountLocked: "LoanAssociationAccountLocked",
    LoanAssociationLockedEmail: "LoanAssociationLockedEmail",
    LoanAssociationRemoved: "LoanAssociationRemoved",
    LoanAssociationAttemptFailure: "LoanAssociationAttemptFailure",
    LoanAssociationAttemptSuccess: "LoanAssociationAttemptSuccess",
    MonthlyStatementAvailable: "MonthlyStatementAvailable",
    MakeAPaymentCompleteAdditionalAmounts: "MakeAPaymentCompleteAdditionalAmounts",
    MakeAPaymentCompleteMonthlyPayment: "MakeAPaymentCompleteMonthlyPayment",
    MakeAPaymentCompletePrincipalReduction: "MakeAPaymentCompletePrincipalReduction",
    MakeAPaymentCompleteTrialPayment: "MakeAPaymentCompleteTrialPayment",
    MakeAPaymentMonthlyPayment: "MakeAPaymentMonthlyPayment",
    MakeAPaymentPendingPaymentCancel: "MakeAPaymentPendingPaymentCancel",
    MakeAPaymentPendingPaymentEdit: "MakeAPaymentPendingPaymentEdit",
    MakeAPaymentStart: "MakeAPaymentStart",
    MakeAPaymentStartAdditionalAmounts: "MakeAPaymentStartAdditionalAmounts",
    MakeAPaymentStartPrincipalReduction: "MakeAPaymentStartPrincipalReduction",
    MakeAPaymentStartTrialPayment: "MakeAPaymentStartTrialPayment",
    PaymentFailed: "PaymentFailed",
    PaymentScheduled_IVR: "PaymentScheduled_IVR",
    PaymentScheduled_Web: "PaymentScheduled_Web",
    PaymentSucceeded: "PaymentSucceeded",
    PayoffDemandRequested: "PayoffDemandRequested",
    PayoffDemandDeliveredtoSecureMessageCenter: "PayoffDemandDeliveredtoSecureMessageCenter",
    PayoffProcessed: "PayoffProcessed",
    AccountChallengeQuestionAnsweredSuccesfully: "AccountChallengeQuestionAnsweredSuccesfully",
    AccountQuestionAnsweredInCorrectly: "AccountQuestionAnsweredInCorrectly",
    SecureMessageRead: "SecureMessageRead",
    SecureMessageReplied: "SecureMessageReplied",
    OutBoundSecureMessage: "OutBoundSecureMessage",
    InboundSecureMessage: "InboundSecureMessage",
    SendEmailAddressConfirmationEmail: "SendEmailAddressConfirmationEmail",
    SendEmailVerificationCode: "SendEmailVerificationCode",
    SendNoAccountEmail: "SendNoAccountEmail",
    SendSmsNumberConfirmationCode: "SendSmsNumberConfirmationCode",
    SendSmsVerificationCode: "SendSmsVerificationCode",
    SendVerificationCode: "SendVerificationCode",
    TaxesPaid: "TaxesPaid",
    TaxesPaidSecureMessage: "TaxesPaidSecureMessage",
    InsurancePaidSecureMessage: "InsurancePaidSecureMessage",
    InsurancePremiumsPaid: "InsurancePremiumsPaid",
    ValidateVerificationCode: "ValidateVerificationCode",
    VerificationPreferenceUpdatedEmail: "VerificationPreferenceUpdatedEmail",
    VerifyEmailVerificationToken: "VerifyEmailVerificationToken",
    VerifyEmailVerificationTokenInvalid: "VerifyEmailVerificationTokenInvalid",
    VerifyForgotUserNameToken: "VerifyForgotUserNameToken",
    VerifyForgotUserNameTokenInvalid: "VerifyForgotUserNameTokenInvalid",
    VerifySmsVerificationToken: "VerifySmsVerificationToken",
    VerifySmsVerificationTokenInvalid: "VerifySmsVerificationTokenInvalid",
    WhiteListDocRequestFulfilled: "WhiteListDocRequestFulfilled",
    WhiteListDocRequestUnfulfilled: "WhiteListDocRequestUnfulfilled",
    YearEndStatementAvailable: "YearEndStatementAvailable",
    WhiteListDocsRequested: "WhiteListDocsRequested",
    EmailBounce: "EmailBounce",
    SendEmailChangeVerificationCode: "SendEmailChangeVerificationCode",
    SyncCustMartToCustomers: "SyncCustMartToCustomers",
    SyncCustMartLoansToMsp: "SyncCustMartLoansToMsp",
    TwoFactorAuthLoginSuccessful: "TwoFactorAuthLoginSuccessful",
    SuccessfullyAuthenticated: "SuccessfullyAuthenticated",
    PaymentConfirmationEmail: "PaymentConfirmationEmail",
    WebChampUserInfoAccess: "WebChampUserInfoAccess",
    WebChampUserPreferenceUpdate: "WebChampUserPreferenceUpdate",
    LanguageToggledToEnglish: "LanguageToggledToEnglish",
    LanguageToggledToSpanish: "LanguageToggledToSpanish",
    UpdateIDSEmail: "UpdateIDSEmail",
    UpdateIDSMobile: "UpdateIDSMobile",
    Debug: "Debug",
    DownloadModDoc: "DownloadModDoc",
    DownldStmtDocUI: "DownldStmtDocUI",
    DownldStmtDocDirect: "DownldStmtDocDirect",
    RedirectRegistrationToPennyHome: "RedirectRegistrationToPennyHome",
    PayoffDemand_Document_Ready: "PayoffDemand_Document_Ready",
    RedirectLogInToPennyHome: "RedirectLogInToPennyHome",
    PayoffDemand_ManuallyProcessed: "PayoffDemand_ManuallyProcessed",
    Payoff_Generated: "Payoff_Generated",
    Payoff_Sent_For_Review: "Payoff_Sent_For_Review",
    PennyWISE_SecureMessageRead: "PennyWISE_SecureMessageRead",
    PennyWISE_DownldStmtDocUI: "PennyWISE_DownldStmtDocUI",
    PennyWISE_DownloadModDoc: "PennyWISE_DownloadModDoc",
    PennyWISE_DownldStmtDocDirect: "PennyWISE_DownldStmtDocDirect",
    FAQ_Link_Clicked: "FAQ_Link_Clicked",
    Wisconsin_Tax_Option_Click: "Wisconsin_Tax_Option_Click",
    Wisconsin_Tax_Option_Submit: "Wisconsin_Tax_Option_Submit",
    Mod_Center_Clicks: "Mod_Center_Clicks",
    Amortization_Calculator_Clicks: "Amortization_Calculator_Clicks",
    BankAccount_Add: "BankAccount_Add",
    BankAccount_Update: "BankAccount_Update",
    BankAccount_Delete: "BankAccount_Delete",
    ModMiscFileUpload_Started: "ModMiscFileUpload_Started",
    WhiteListedDocNotification: "WhiteListedDocNotification",
    DisasterAssistancePopupDisplay: "DisasterAssistancePopupDisplay",
    DisasterAssistanceCancel: "DisasterAssistanceCancel",
    DisasterAssistanceGoBack: "DisasterAssistanceGoBack",
    DisasterAssistanceSubmit: "DisasterAssistanceSubmit",
    MakeADelinquent30DayPayment: "MakeADelinquent30DayPayment",
    MakeADelinquent30DayPaymentComplete: "MakeADelinquent30DayPaymentComplete",
    PennyPaperlessSignUp: "PennyPaperlessSignUp",
    AchUpdate_OtpOpted: "AchUpdate_OtpOpted",
    MobileTokenLoginFailed: "MobileTokenLoginFailed",
    MobileTokenLoginSucessful: "MobileTokenLoginSucessful",
    OnboardingAllowPushNotifications: "OnboardingAllowPushNotifications",
    OnboardingEnableTouchId: "OnboardingEnableTouchId",
    OnboardingSkipNow: "OnboardingSkipNow",
    ScheduleQuickPayment: "ScheduleQuickPayment",
    PaymentScreenDone: "PaymentScreenDone",
    PaymentThankYouPageOk: "PaymentThankYouPageOk",
    AllowPushNotifications: "AllowPushNotifications",
    PaymentReminderDaySelection: "PaymentReminderDaySelection",
    EnableTouchId: "EnableTouchId",
    AppSettingsLogout: "AppSettingsLogout",
    AppStateChange: "AppStateChange",
    LoginTouchId: "LoginTouchId",
    ModFileUpload_Started: "ModFileUpload_Started",
    ModFileUpload_Completed: "ModFileUpload_Completed",
    ModMiscFileUpload_Completed: "ModMiscFileUpload_Completed",
    QuickLinkMakeAPaymentClicked: "QuickLinkMakeAPaymentClicked",
    QuickLinkLoanActivityClicked: "QuickLinkLoanActivityClicked",
    QuickLinkMessageCenterClicked: "QuickLinkMessageCenterClicked",
    QuickLinkMonthlyStatementClicked: "QuickLinkMonthlyStatementClicked",
    AppNormalLogin: "AppNormalLogin",
    ServCommOnline: "ServCommOnline",
    ServCommBoth: "ServCommBoth",
    PMIPageLoadedFromOtherPageEvent: "PMIPageLoadedFromOtherPageEvent",
    PMIPageLoadedByNavEvent: "PMIPageLoadedByNavEvent",
    PMIBannerLinkClickedEvent: "PMIBannerLinkClickedEvent",
    AutoLoanAssociationSuccess: "AutoLoanAssociationSuccess",
    HelocDrawAddRequestSuccess: "HelocDrawAddRequestSuccess",
    HelocDrawAddRequestFailed: "HelocDrawAddRequestFailed",
    HelocDrawEditRequestSuccess: "HelocDrawEditRequestSuccess",
    HelocDrawEditRequestFailed: "HelocDrawEditRequestFailed",
    HelocDrawCancelRequestSuccess: "HelocDrawCancelRequestSuccess",
    HelocDrawCancelRequestFailed: "HelocDrawCancelRequestFailed",
    MakeADrawStart: "MakeADrawStart",
    MakeADrawComplete: "MakeADrawComplete",
    HelocBankAccountChanged: "HelocBankAccountChanged",
    ContinueToBillMatrix: "ContinueToBillMatrix",
    BackToPennyMacClick: "BackToPennyMacClick",
    PaymentWithCheckingClick: "PaymentWithCheckingClick",
    PaymentWithSavingsClick: "PaymentWithSavingsClick",
    PaymentWithDebitCardClick: "PaymentWithDebitCardClick",
    ReturnedFromFiserv: "ReturnedFromFiserv",
    BackToPennyMacPaymentReturn: "BackToPennyMacPaymentReturn",
    RedirectToPendingPayments: "RedirectToPendingPayments",
    RedirectToPaymentStep1: "RedirectToPaymentStep1",
    NoFiservCuzCashCallFailed: "NoFiservCuzCashCallFailed",
    FiservOkButCashNotOkRedirectToLoanInfo: "FiservOkButCashNotOkRedirectToLoanInfo",
    UserChangedPaymentMethod: "UserChangedPaymentMethod",
    UserSentToFiServPaymentPage: "UserSentToFiServPaymentPage",
    EscrowAnalysisAndPaymentChange: "EscrowAnalysisAndPaymentChange",
    MobAppLoanInformationPageOpened: "MobAppLoanInformationPageOpened",
    MobAppMakeAPaymentPageOpened: "MobAppMakeAPaymentPageOpened",
    MobAppPendingPaymentsPageOpened: "MobAppPendingPaymentsPageOpened",
    MobAppLoanActivityPageOpened: "MobAppLoanActivityPageOpened",
    MobAppEscrowPageOpened: "MobAppEscrowPageOpened",
    MobAppMoreFeaturesPageOpened: "MobAppMoreFeaturesPageOpened",
    MobAppOffersPageOpened: "MobAppOffersPageOpened",
    MobAppSettingsPageOpened: "MobAppSettingsPageOpened",
    TCPAOnlineAgreementPopUpClick: "TCPAOnlineAgreementPopUpClick",
    OTDConfirmationPopupDisplay: "OTDConfirmationPopupDisplay",
    OTDConfirmationPopupCancelClicked: "OTDConfirmationPopupCancelClicked",
    OTDConfirmationPopupContinueClicked: "OTDConfirmationPopupContinueClicked",
    ForbearancePlanPrompt1: "ForbearancePlanPrompt1",
    ForbearancePlanPrompt2: "ForbearancePlanPrompt2",
    ForbearancePlanPrompt3: "ForbearancePlanPrompt3",
    ForbearancePlanPrompt4: "ForbearancePlanPrompt4",
    ForbearancePlanPrompt5: "ForbearancePlanPrompt5",
    ForbearancePlanPrompt6: "ForbearancePlanPrompt6",
    MakeAPaymentCompleteForbearancePayment: "MakeAPaymentCompleteForbearancePayment",
    MOVRMessageOnLogInDisplayed: "MOVRMessageOnLogInDisplayed",
    MOVRLinkClicked: "MOVRLinkClicked",
    ReturnedFromMOVR: "ReturnedFromMOVR",
    ChangePasswordFailed: "ChangePasswordFailed",
    DebugLog: "DebugLog",
    LoanAssociationViewRedirected: "LoanAssociationViewRedirected",
    ServicingAppRedirected: "ServicingAppRedirected",
    RetailAppRedirected: "RetailAppRedirected",
    ServicingLoanSelected: "ServicingLoanSelected",
    RetailLoanSelected: "RetailLoanSelected",
    UserLogOutEvent: "UserLogOutEvent",
    RecordLoanAssociation: "RecordLoanAssociation",
    TechnicalErrorEncountered: "TechnicalErrorEncountered",
    NoTechnicalErrors: "NoTechnicalErrors",
    IdsApiCallForPhoneChange: "IdsApiCallForPhoneChange",
    IdsApiCallForEmailChange: "IdsApiCallForEmailChange",
    FixingLoanAssociationAtUserProfile: "FixingLoanAssociationAtUserProfile"
  }[value];
};
var TrackerCategoryLID = function (value) {
  return {
    Button: 220,
    CheckBox: 227,
    Div: 218,
    Element: 215,
    Forms: 216,
    Image: 221,
    Nav: 217,
    Page: 214,
    Radio: 226,
    SelectMultiple: 223,
    SelectOne: 222,
    Service: 259,
    Span: 219,
    Text: 224,
    TextArea: 225
  }[value];
};
export var TrackerCategoryLID_ENUM = {
  Button: "Button",
  CheckBox: "CheckBox",
  Div: "Div",
  Element: "Element",
  Forms: "Forms",
  Image: "Image",
  Nav: "Nav",
  Page: "Page",
  Radio: "Radio",
  SelectMultiple: "SelectMultiple",
  SelectOne: "SelectOne",
  Service: "Service",
  Span: "Span",
  Text: "Text",
  TextArea: "TextArea"
};
var TrackerActionLID = function (value) {
  return {
    Click: 231,
    Method: 260,
    Select: 230,
    Submit: 229,
    View: 228
  }[value];
};
export var TrackerActionLID_ENUM = {
  Click: "Click",
  Method: "Method",
  Select: "Select",
  Submit: "Submit",
  View: "View"
};
export var eventTracker = function (loanId, borrowerId, userLanguage, trackerCategoryLID, trackerHitTypeLID, trackerActionLID, label, Value, jsonEventData, trackerSession, mobile, msrID) {
  var _a, _b, _c;
  if (userLanguage === void 0) {
    userLanguage = "English";
  }
  if (trackerCategoryLID === void 0) {
    trackerCategoryLID = "Page";
  }
  if (trackerHitTypeLID === void 0) {
    trackerHitTypeLID = "PageView";
  }
  if (trackerActionLID === void 0) {
    trackerActionLID = "View";
  }
  if (label === void 0) {
    label = "Pages Viewed";
  }
  if (jsonEventData === void 0) {
    jsonEventData = null;
  }
  if (trackerSession === void 0) {
    trackerSession = 0;
  }
  if (mobile === void 0) {
    mobile = false;
  }
  if (msrID === void 0) {
    msrID = "001";
  }
  var eve = {
    "TrackerId": 0,
    "TrackerSessionId": trackerSession,
    "LoanId": loanId,
    "BorrowerId": borrowerId,
    "MSRID": msrID,
    "IpAddress": "string",
    "TrackerHitTypeLId": TrackerHitTypeLID(trackerHitTypeLID),
    "TrackerCategoryLId": TrackerCategoryLID(trackerCategoryLID),
    "TrackerActionLId": TrackerActionLID(trackerActionLID),
    "Label": mobile ? label.includes('WI Tax Option Change button clicked') ? label : "Mobile Tracker Event ".concat(label) : label,
    "Value": Value === -1 ? 0 : Value,
    "Page": mobile || Value === -1 ? '' : "".concat((_a = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _a === void 0 ? void 0 : _a.hostname).concat((_b = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _b === void 0 ? void 0 : _b.pathname),
    "URL": mobile || Value === -1 ? '' : (_c = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _c === void 0 ? void 0 : _c.pathname,
    "CreatedUTC": moment(new Date()).format("MM/DD/YYYY hh:mm"),
    "LanguageId": UserLanguage(userLanguage),
    "JsonEventData": jsonEventData ? JSON.stringify(jsonEventData) : ""
  };
  return eve;
};
export var event = function (loanId, data, eventTypeLid, eventStatusLid, userLanguage) {
  if (eventTypeLid === void 0) {
    eventTypeLid = "AcceptedTermsAndConditions";
  }
  if (eventStatusLid === void 0) {
    eventStatusLid = "Exception";
  }
  if (userLanguage === void 0) {
    userLanguage = "English";
  }
  var eve = {
    "EventId": 0,
    "UserId": 0,
    "LoanId": loanId,
    "IpAddress": "",
    "EventTypeLid": EventTypeLID(eventTypeLid),
    "EventStatusLid": EventStatusLID(eventStatusLid),
    "CreatedUTC": moment(new Date()).format("MM/DD/YYYY hh:mm"),
    "ModifiedUTC": moment(new Date()).format("MM/DD/YYYY hh:mm"),
    "LanguageId": UserLanguage(userLanguage),
    "ApplicationIdentifier": "PNMAC.Customers.Web",
    "MobileApp": false,
    "Language": UserLanguage(userLanguage),
    "EventData": []
  };
  if (data) {
    eve.EventData.push({
      "EventDataId": 0,
      "EventId": 0,
      "EventDataObjectType": "JS OBject",
      "EventDataObjectSerialized": JSON.stringify(data),
      "CreatedUTC": moment(new Date()).format("MM/DD/YYYY hh:mm:ss"),
      "IsResponseData": false
    });
  }
  return eve;
};